import React from 'react';
import { Parallax } from 'react-scroll-parallax';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import './Hero.css';

const Hero = ({ onBookNow }) => {
  return (
    <section id="hero" className="hero-section">
      <Parallax speed={-20} className="hero-parallax">
        <div className="hero-background">
          <img
            src="/images/1.jpg"
            alt="Mountain landscape"
            className="hero-image"
          />
          <div className="hero-overlay"></div>
        </div>
      </Parallax>

      <div className="hero-content">
        <motion.div
          initial={{ opacity: 0, y: 50, scale: 0.95 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          transition={{ duration: 1, delay: 0.2, ease: 'easeOut' }}
          className="hero-text-container"
        >
          <motion.h1 
            className="hero-large"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
          >
            Escape to Peace at The Heaven Town Homestay
          </motion.h1>
          <motion.p 
            className="body-large hero-subtext"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.6 }}
          >
            Cozy rooms, breathtaking views, and heartfelt hospitality.
          </motion.p>
          <motion.button 
            className="btn-primary" 
            onClick={onBookNow}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.8 }}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            Book Now
            <ArrowRight size={16} />
          </motion.button>
        </motion.div>

        {/* Floating particles removed - no emoji icons as per design guidelines */}
      </div>
    </section>
  );
};

export default Hero;
